module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_1@2x.aa9650ec.png";